// RecentlyViewed.styles.js
import styled from '@emotion/styled';
import { Button, ProductCard } from '@nike/nike-design-system-components';
import { breakpoints } from '@nike/nike-design-tokens';

const { podiumCdsBreakpointS } = breakpoints;

export const RecentlyViewedContainer = styled.div`
  max-height: 5%;
  width: auto;
  display: grid;
  gap: var(--podium-cds-size-spacing-m);
  padding: 12px 0;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ClearButton = styled(Button)`
  background-color: inherit;
  color: var(--podium-cds-color-text-secondary);
  cursor: pointer;
  font: var(--podium-cds-typography-body2);

  &:hover {
    color: var(--podium-cds-color-text-primary);
  }
`;

export const StyledProductCard = styled(ProductCard)`
  // Override the default strikethrough text for India
  .nds-text.price {
    color: var(--podium-cds-color-text-secondary);
    text-decoration: none;
  }
`;

export const StyledList = styled.ul`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--podium-cds-size-spacing-grid-gutter-l);
  margin-top: 4px;

  @media (max-width: ${podiumCdsBreakpointS}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
